import React from 'react';
import { useTranslation } from 'react-i18next';
import { User } from '../../types';

interface BlockedUserPopupProps {
  user: User;
  onSignOut: () => void;
}

export function BlockedUserPopup({ user, onSignOut }: BlockedUserPopupProps) {
  const { t } = useTranslation();

  return (
    <div className="blocked-popup-overlay">
      <div className="blocked-popup-content">
        <div className="blocked-popup-header">
          <h1>🚫 {t('blocked.accessDenied')}</h1>
        </div>
        <div className="blocked-popup-body">
          <div className="blocked-icon">🔒</div>
          <h2>{t('blocked.youHaveBeenBlocked')}</h2>
          <p>{t('blocked.accountSuspended')}</p>
          {user?.blockedReason && (
            <div className="blocked-reason">
              <strong>{t('blocked.reason')}</strong> {user.blockedReason}
            </div>
          )}
          <p>{t('blocked.contactAdministrator')}</p>
        </div>
        <div className="blocked-popup-footer">
          <button 
            onClick={onSignOut}
            className="blocked-signout-btn"
          >
            {t('blocked.signOut')}
          </button>
        </div>
      </div>
    </div>
  );
}

